import redirectInterceptor from "@/interceptors/redirect_interceptor";

export default class WeatherDataService {

  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }

  async getWindData(accessToken,vesselName, startDate, stopDate) {
    try {
      const response = await redirectInterceptor.get(
        `${this.baseUrl}/vesselInformation/${vesselName}/voyageWindDataFromProvider`,
        {
          params: {
            startDate: startDate,
            stopDate: stopDate
          },
          headers: { Authorization: `${accessToken}` }
        }
      );
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }

}

export async function getWavelength(vesselName, startDate, stopDate) {
  const basicUrl = process.env.VUE_APP_BASIC_URL || localStorage.getItem("basicUrl");

  const response = await redirectInterceptor.get(
    `${basicUrl}/vesselInformation/${vesselName}/wavelength`,
    {
      params: {
        startDate,
        stopDate,
      },
      headers: {
        Authorization: localStorage.getItem("quad_token"),
      },
    }
  );

  return response.data;
}
